import apiClient, {timeouts} from 'shared/services/apiClient';
import {endpoints} from "shared/services/endpoints";
import {GetUsersResp, UpdateUserResp} from "../types";
import {SuccessResponse} from "shared/types/common";

export const adminService = {
    getUsers: async () => {
        return apiClient
            .get<GetUsersResp>(endpoints.users.list, {timeout: timeouts.mediumOperationsTimeout})
            .then(r => r.data as GetUsersResp).catch((reason) => {
                return {users: [], errorCode: reason.response !== undefined? reason.response.status : reason.request.status } as GetUsersResp;
            }
        );
    },

    createUser: async (login: string, password: string) => {
        return apiClient
            .post<UpdateUserResp>(endpoints.users.list, {login, password}, {timeout: timeouts.mediumOperationsTimeout})
            .then(r => r.data as UpdateUserResp).catch((reason) => {
                return {success: false, message: "", users: [], errorCode: reason.response !== undefined? reason.response.status : reason.request.status } as UpdateUserResp;
            }
        );
    },

    promoteUser: async (user_id: number) => {
        return apiClient
            .post<UpdateUserResp>(endpoints.users.byId(user_id), {}, {timeout: timeouts.mediumOperationsTimeout})
            .then(r => r.data as UpdateUserResp).catch((reason) => {
                return {success: false, message: "", errorCode: reason.response !== undefined? reason.response.status : reason.request.status } as UpdateUserResp;
            }
        );
    },

    demoteUser: async (user_id: number) => {
        return apiClient
            .put<UpdateUserResp>(endpoints.users.byId(user_id), {}, {timeout: timeouts.mediumOperationsTimeout})
            .then(r => r.data as UpdateUserResp).catch((reason) => {
                return {success: false, message: "", errorCode: reason.response !== undefined? reason.response.status : reason.request.status } as UpdateUserResp;
            }
        );
    },

    deleteUser: async (user_id: number) => {
        return apiClient
            .delete<UpdateUserResp>(endpoints.users.byId(user_id), {timeout: timeouts.complexOperationsTimeout})
            .then(r => r.data as UpdateUserResp).catch((reason) => {
                return {success: false, message: "", errorCode: reason.response !== undefined? reason.response.status : reason.request.status } as UpdateUserResp;
            }
        );
    },

    clearAllCache: async () => {
        return apiClient
            .delete<SuccessResponse>(endpoints.users.clearCache, {timeout: timeouts.complexOperationsTimeout})
            .then(r => r.data as SuccessResponse)
            .catch((reason) => {
                return {success: false, errorCode: reason.response !== undefined? reason.response.status : reason.request.status } as SuccessResponse;
            }
        );
    }
};
